<template>
  <div
      class="responsive-image-container"
      style="padding-bottom: 100%"
      v-bind:style="{
            backgroundColor:
                image.dominantColor && !image.hasTransparency
                    ? image.dominantColor
                    : 'transparent',
            paddingBottom: (image.height / image.width) * 100 + '%',
        }"
  >
    <img
        class="responsive-image lazyload"
        v-bind:data-srcset="generateSrcSet(image.sizes)"
        v-bind:data-src="image.default"
        v-bind:data-aspectratio="image.width / image.height"
        v-bind:src="
                'data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
            "
        data-sizes="auto"
        v-bind:alt="image.alt"
    />
    <component is="noscript" v-if="isSSR">
      <img
          class="responsive-image"
          v-bind:src="image.default"
          v-bind:alt="image.alt"
      />
    </component>
  </div>
</template>

<script>
export default {
  props: ['image', 'image-class', 'default-image'],
  computed: {
    isSSR: function () {
      return typeof window === 'undefined';
    },
  },
  methods: {
    generateSrcSet: function(input) {
      return Object.entries(input)
          .map(([key, value]) => `${value} ${key}w`)
          .join(', ');
    },
  },
};
</script>
